import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHuFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53495)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 19.5402H0.000488281V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271L50.0004 19.5402Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1383 41.3795H0.862596C0.386523 41.3795 0.000488281 40.9934 0.000488281 40.5174V30.46H50.0004V40.5174C50.0004 40.9935 49.6144 41.3795 49.1383 41.3795Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 19.54H0.000488281V30.459H50.0004V19.54Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53495",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHuFlag);
export { ForwardRef as ReactComponent };
